import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';

function ReusableModal({ show, handleClose, details }) {

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{details.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{details.body}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>

          <Link to="/cart">
            <Button variant="primary" onClick={handleClose}>
            {details.submitButton}
            </Button>
          </Link>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ReusableModal;